import React from "react";
import SEO from "@/components/SEO";
import LocationTemplate from "@/components/LocationTemplate";

const StrathmoreHeightsPage = () => (
  <LocationTemplate suburbName="Strathmore Heights" suburbSlug="strathmore-heights" />
);

export default StrathmoreHeightsPage;
